import React from "react";
import { Instagram, ArrowUpRight } from "lucide-react";
import { CONTACT } from "../../mock/mockData";

const Footer = () => {
  return (
    <footer className="border-t-[3px] border-black bg-black text-white">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10 py-12 md:py-16">
        <div className="grid md:grid-cols-[1.5fr_1fr_1fr_1fr] gap-10">
          <div>
            <div className="flex items-center gap-2">
              <div className="w-10 h-10 bg-[#FFD60A] flex items-center justify-center">
                <span className="display font-bold text-black text-xl">V</span>
              </div>
              <div className="flex flex-col leading-none">
                <span className="display font-bold text-[17px] tracking-tight">VEENTTO</span>
                <span className="mono text-[10px] uppercase text-white/60 tracking-widest">B2B / 2026</span>
              </div>
            </div>
            <p className="mt-5 text-[14px] leading-[1.6] text-white/70 max-w-[360px]">
              Programa B2B para revendedores de scooters electricas 100% litio. Lisboa &amp; Vagos. Stock em solo portugues.
            </p>
            <div className="mt-6 flex gap-2">
              <a
                href="https://www.instagram.com/veenttovagos"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 bg-[#FFD60A] text-black mono text-[12px] uppercase font-bold tracking-wider px-4 py-3 brut-border brut-btn"
              >
                <Instagram size={16} /> @veenttovagos
              </a>
            </div>
          </div>

          <FooterCol
            title="Programa"
            links={[
              { label: "Catalogo", href: "#modelos" },
              { label: "Tabela", href: "#tabela" },
              { label: "Calculadora", href: "#calculadora" },
              { label: "FAQ", href: "#faq" },
            ]}
          />
          <FooterCol
            title="Modelos"
            links={[
              { label: "Power", href: "#modelos" },
              { label: "Nice", href: "#modelos" },
              { label: "Briza", href: "#modelos" },
            ]}
          />
          <FooterCol
            title="Contacto"
            links={[
              { label: "+351 928 272 818", href: "tel:+351928272818" },
              { label: "b2b@veenttovagos.com", href: "mailto:b2b@veenttovagos.com" },
              { label: "Vagos / Aveiro", href: "#candidatura" },
              { label: "Lisboa / Loja", href: CONTACT.lisbonStoreUrl, external: true },
            ]}
          />
        </div>

        <div className="mt-12 pt-6 border-t-[3px] border-white/20 flex flex-col md:flex-row md:items-center md:justify-between gap-3 mono text-[11px] uppercase tracking-widest text-white/60">
          <span>2026 Veentto Vagos / Todos os direitos reservados</span>
          <span>Programa B2B Revendedores / Tabela 05/05/2026</span>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, links }) => (
  <div>
    <div className="mono text-[11px] uppercase tracking-widest text-[#FFD60A] font-bold mb-4">{title}</div>
    <ul className="space-y-2">
      {links.map((link) => (
        <li key={link.label}>
          <a
            href={link.href}
            target={link.external ? "_blank" : undefined}
            rel={link.external ? "noreferrer" : undefined}
            className="group inline-flex items-center gap-1 text-[14px] text-white/80 hover:text-[#FFD60A] transition-colors"
          >
            {link.label}
            <ArrowUpRight size={14} className="opacity-0 group-hover:opacity-100 transition-opacity" />
          </a>
        </li>
      ))}
    </ul>
  </div>
);

export default Footer;
